import ProjectTeamResponseResource from "common/resources/Project/Config/Team/ProjectTeamResponseResource";
import BaseTeamApi from "./BaseTeamApi";

export default class TeamApi extends BaseTeamApi {
	/**
	 * @description Get by project id
	 */
	public async getByProjectId(projectId: string): Promise<ProjectTeamResponseResource> {
		return this.getRequest<ProjectTeamResponseResource>(this.getBaseUrl({ projectId })).then((response) => ProjectTeamResponseResource.hydrate(response));
	}

	/**
	 * @description Create an empty project team, or get the existing one
	 */
	public async create(projectId: string): Promise<ProjectTeamResponseResource> {
		return this.postRequest<ProjectTeamResponseResource>(this.getBaseUrl({ projectId }));
	}
}
